function useAuth() {
	return {
		authenticated: true,
		authStateChanged: () => {},
		signIn: () => {},
		signUp: () => {},
		signOut: () => {}
	}
}

export default useAuth